import { Helmet } from 'react-helmet-async';
import { useLanguage } from '@/hooks/useLanguage';
import { ChevronDown } from 'lucide-react';

const HERO_IMAGE = 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1920&auto=format&fit=crop';

export const HeroSection = () => {
  const { t } = useLanguage();

  const scrollToCategories = () => {
    document.getElementById('categories')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-[75vh] md:min-h-[85vh] flex items-center justify-center overflow-hidden">
      <Helmet>
        <link rel="preload" as="image" href={HERO_IMAGE} />
      </Helmet>

      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Mountain landscape representing alternative living"
          className="w-full h-full object-cover"
          fetchPriority="high"
          loading="eager"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 md:px-8 text-center">
        {/* Decorative line */}
        <div className="w-12 h-px bg-white/60 mx-auto mb-8 animate-fade-in" />
        
        <h1 
          className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-medium text-white mb-8 animate-fade-in tracking-tight leading-[1.1]"
          style={{ textShadow: '0 2px 30px rgba(0,0,0,0.4)' }}
        >
          {t('hero.title')}
        </h1>
        
        <p 
          className="text-base md:text-lg text-white/90 max-w-xl mx-auto mb-12 animate-fade-in font-light leading-relaxed tracking-wide"
          style={{ animationDelay: '0.2s', textShadow: '0 1px 15px rgba(0,0,0,0.5)' }}
        >
          {t('hero.subtitle')}
        </p>
        
        <button
          onClick={scrollToCategories}
          className="group inline-flex items-center gap-3 px-8 py-4 bg-white/95 text-primary hover:bg-white transition-all duration-500 animate-fade-in text-xs tracking-luxury uppercase font-medium shadow-lg"
          style={{ animationDelay: '0.4s' }}
        >
          {t('hero.cta')}
          <ChevronDown className="w-4 h-4 group-hover:translate-y-0.5 transition-transform duration-500" strokeWidth={1.5} />
        </button>
      </div>

      {/* Decorative element */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent" />
    </section>
  );
};
